import React from 'react';
import {
  Box,
  Card,
  Typography,
  Button,
  Chip,
  Alert,
  CircularProgress,
  alpha,
  useTheme
} from '@mui/material';
import {
  AutoAwesome as AutoAwesomeIcon,
  Edit as EditIcon,
  CheckCircle as CheckCircleIcon,
  Warning as WarningIcon
} from '@mui/icons-material';


const AILineMappingSummary = ({ 
  aiSuggestion, 
  loading, 
  onEditMapping,
  onApproveMapping  
}) => {
  const theme = useTheme();

  const formatConfidence = (confidence) => {
    if (confidence === undefined || confidence === null) return 0;
    return Number(confidence.toFixed(2));
  };

  if (loading) {
    return (
      <Card
        sx={{
          p: 3,
          mb: 3,
          bgcolor: alpha(theme.palette.info.main, 0.04),
          border: '2px solid',
          borderColor: 'info.light',
          borderRadius: 2,
          display: 'flex',
          alignItems: 'center',
          gap: 2
        }}
      >
        <CircularProgress size={24} />
        <Typography>בודק שיוך אוטומטי...</Typography>
      </Card>
    );
  }

  if (!aiSuggestion) {
    return null;
  }

  const { overallConfidence, mappings = [], summary, warnings = [] } = aiSuggestion;

  const getConfidenceColor = () => {
    if (overallConfidence >= 80) return 'success';
    if (overallConfidence >= 60) return 'warning';
    return 'error';
  };

  const confidenceColor = getConfidenceColor();

  return (
    <Card
      sx={{
        p: 3,
        mb: 3,
        bgcolor: alpha(theme.palette.primary.main, 0.04),
        border: '2px solid',
        borderColor: 'primary.light',
        borderRadius: 2
      }}
    >
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
        <Box sx={{ flex: 1 }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 2 }}>
            <AutoAwesomeIcon color="primary" />
            <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
              שיוך אוטומטי בוצע
            </Typography>
            <Chip
              label={`${formatConfidence(overallConfidence)}% ביטחון`}
              color={confidenceColor}
              size="small"
              icon={overallConfidence >= 80 ? <CheckCircleIcon /> : <WarningIcon />}
              sx={{ fontWeight: 600 }}
            />
          </Box>

          <Typography variant="body1" sx={{ mb: 1.5 }}>
            {summary}
          </Typography>

          {warnings.length > 0 && (
            <Alert severity="warning" sx={{ mt: 2 }} icon={<WarningIcon />}>
              {warnings[0]}
            </Alert>
          )}
        </Box>

        <Box sx={{ display: 'flex', gap: 1.5, alignItems: 'center' }}>
          <Button
            variant="outlined"
            color="primary"
            startIcon={<EditIcon />}
            onClick={onEditMapping}
            sx={{
              minWidth: 120,
              height: 40
            }}
          >
            ערוך שיוך
          </Button>
          
          {onApproveMapping && (
            <Button
              variant="contained"
              color="success"
              startIcon={<CheckCircleIcon />}
              onClick={onApproveMapping}
              sx={{
                minWidth: 120,
                height: 40
              }}
            >
              אשר והמשך
            </Button>
          )}
        </Box>
      </Box>
    </Card>
  );
};

export default AILineMappingSummary;